<template>
    <div>
        <div class="row wrapper border-bottom white-bg page-heading">
            <div class="col-lg-10">
                <h2>Subject Milestones</h2>
            </div>
        </div>

        <div class="wrapper wrapper-content">
            <div class="ibox-body mt-2">
                <div class="ibox-title style_2 d-flex justify-content-between">
                    <h5 class="mt-1">Milestone List</h5>

                    <div class="position-relative align-self-center" :class="{ 'mr-3': milestoneList.length != 0 }"
              aria-label="Create Cycle" tabindex="0" v-if="rollsprivilages.includes('Subject Milestones Create')">
                        <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="17"
                            @click="createMilestone" />
                        <div class="tool-tip">Create Milestone</div>
                    </div>
                </div>

                <div class="ibox-content">

                    <!-- Loader -->
                    <div class="text-center" v-if="loading">
                        <img src="../../assets/img/loading.gif" width="15" />
                        <div>Loading milestones...</div>
                    </div>

                    <!-- Table -->
                    <div v-else class="table-responsive">
                        <table class="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th class="sort_block" @click="SortSelected('MilestoneName', 1)">
                                    <div class="d-flex flex-row justify-content-between">
                                            Milestone Name
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>
                                    <th class="text-center">Active</th>
                                    <th class="text-center" v-if="rollsprivilages.includes('Subject Milestones Edit')">Edit</th>
                                    <th class="text-center" v-if="rollsprivilages.includes('Subject Milestones Delete')">Delete</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item in milestoneList" :key="item.id">
                                    <td>{{ item.milestoneName }}</td>

                                    <td class="text-center">
                                        <input type="checkbox" :checked="item.active" readonly />
                                    </td>

                                    <td class="text-center" v-if="rollsprivilages.includes('Subject Milestones Edit')">
                                        <i class="fa fa-edit edit-delete" @click="editMilestone(item.id)"></i>
                                    </td>

                                    <td class="text-center" v-if="rollsprivilages.includes('Subject Milestones Delete')">
                                        <i class="fa fa-trash edit-delete" @click="deleteMilestone(item.id)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Pagination -->
                    <div v-if="milestoneList.length != 0" class="row mt-1 mx-0">
                        <div class="col-lg-12 mx-0 px-0">
                            <div class="
                  dataTables_paginate
                  paging_simple_numbers
                  pagination
                  float-right
                ">
                                <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                                    <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1"
                                        active-color="#618bd7" @update:modelValue="loadPage" />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>

        <!-- Modal -->
        <MilestoneModal
      v-if="showModal"
      :editingId="editingId"
      @closeModal="closeModal"
      @saved="getMilestones"
    />
    </div>
</template>
<script src="./SubjectMilestone.js"></script>
<style>
</style>